import { Link } from "react-router";
import { parseHintText } from "@/lib/hint-links";

interface WelcomeMessageTextProps {
  message: string;
  className?: string;
  onLinkClick?: () => void;
  /** Anker-Präfix der Verweise; vom Aufrufer, weil Hinweis und Dialog denselben Text rendern. */
  idPrefix?: string;
}

// The admin-authored message as plain text plus the [Text](/path) links that
// hint-links.ts allows. `text-smycles-title` is one step above `.smycles-field-value` on purpose:
// this is announcement copy that customers overlooked at 14px (bd-requirements #8), not field
// content. It used to sit at 16px, deliberately below the box-title tier; the type ladder has no
// step between 14 and 18 (@adr SPARK-0046-one-type-ladder-no-raw-font-sizes@1), and 14 was the
// complaint, so it now shares the title rung.
export function WelcomeMessageText({ message, className = "", onLinkClick, idPrefix }: WelcomeMessageTextProps) {
  return (
    <div className={`whitespace-pre-wrap text-smycles-title leading-relaxed text-ink ${className}`}>
      {parseHintText(message).map((segment, i) =>
        segment.type === "link" ? (
          <Link
          key={i}
          id={idPrefix ? `${idPrefix}-link-${i}` : undefined}
          to={segment.href}
          onClick={onLinkClick}
          className="text-ink-accent underline"
        >
            {segment.text}
          </Link>
        ) : (
          <span key={i}>{segment.value}</span>
        ),
      )}
    </div>
  );
}
